import React, {useState} from 'react';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './SuccessStories.module.pcss';
import Container from 'js/components/Common/Container/Container';
import Heading from 'js/components/Common/Heading/Heading';
import parse from 'html-react-parser';

interface Props {
    pageId: number
}

type CardType = {
	title: string,
	description: string
}

const SuccessStories = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [cards, setCards] = useState<Array<CardType>>(null);

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
			const result = data?.page?.ServicesTemplate;
			setTitle(result?.titleStories);
			setCards(result?.successCards);
        }
    });

    return (
        <DataValidator data={!isLoading && !error && cards?.length > 0}>
            <section className={classes.SuccessStories}>
                <Container>
                    <Heading text={title} />
                </Container>
				<Container additionalClass={`${classes.Wrap} ${cards?.length === 1 ? classes.Singular : ''}`}>
					<div className={classes.Cards}>
						{cards?.map((item, index) => (
							<div key={index} className={classes.Card}>
								<Heading text={item?.title} type={'h4'} />
								<div className={classes.Info}>{parse(item?.description || '')}</div>
							</div>
						))}
					</div>
				</Container>
			</section>
        </DataValidator>
    );
};

export default SuccessStories;
